module.exports = __webpack_public_path__ + "static/transcripts.baeda806.png";